<template>
    <span class="wrapper">
        <div class="header-area">
            <NavBarDark @challenge_clicked="signUp"></NavBarDark>
            <div class="message text-left"><h1 class="heading-white">Take real-world challenges to <span class="typed_static">practice </span> <span class="typed_element"></span></h1></div>
            <b-button v-on:click="signUp" class="signup-btn">SIGN UP</b-button><br><br>
        </div>
        <div class="description text-left">
            <div>
                <h1 class="heading">Practical learning is the best way to learn</h1>
                <div>At Product Planet, we strongly believe that the best way to learn is by doing.
                    We have a ton of practice challenges so you can prepare your front-end developer 
                    skills in Javascript, React, mobile developer skills in Android, React Native, and Java, and UI/UX design skills.<br><br>
                    We are very different from other platforms out there because we believe in learning employable skills that
                    will help you get a job rather than just theory or competitive programming.
                </div>
                <br><br>
                <h3 class="label-heading">Develop employable skills</h3>
                <div>When you practice one of our skills challenges like UI/UX, Javascript, React, we tell you where you 
                    lack, so that you can use that feedback to improve and stand out as a candidate. <br><br>
                    Your skills are your best strength when you look for jobs.  
                </div>
                <br><br>
                <h3 class="label-heading">Find out where you stand</h3>
                <div>Take our challenges to understand where you stand and how much more you need to prepare to 
                    get your dream job. 
                </div>
                <br><br>
                <h3 class="label-heading">Personalised learning path and projects</h3>
                <div>For a small fee, we create a personalised learning path for you that will help you showcase your skills
                    on GitHub, Behance, etc. through projects. Every company looks for relevant job-related projects, and this
                    really makes you stand out as a jobseeker. So you should really focus on showcasing your projects.
                    By doing so, you can really enhance your portfolio
                    and grab that opportunity. <br>  
                </div>

            </div>
        </div>

        <div class="footer-component">
            <FooterDark></FooterDark>
        </div>
    </span>
</template>

<script>
import NavBarDark from '@/components/NavBarDark.vue'
import FooterDark from '@/components/FooterDark.vue'
import firebase from '../services/firebase'
import router from '../router'
import Typed from 'typed.js';
export default {
    name: 'Practice',
    components: {
        NavBarDark,
        FooterDark
    },
    mounted: function() {
      var typed = new Typed('.typed_element', {
          strings: ["UX Design", "UI Design", "Frontend Development"],
          smartBackspace: true,
          typeSpeed: 100,
          loop: true,
          loopCount: Infinity,
          showCursor: false
      });
    },
    methods: {
        signUp: function() {
          console.log("inside signUp vue function");
          var provider = new firebase.auth.GoogleAuthProvider();
          var user = firebase.auth().currentUser;
          if (user === undefined || user === null) {
              firebase.auth().signInWithPopup(provider).then(function(result) {
                var user = result.user;
                var token = result.credential.accessToken;
                localStorage.token = token;
                var full_name = result.user.displayName;
                var first_name = full_name.split(" ");
                if (result.additionalUserInfo.isNewUser === true) {
                    mixpanel.identify(result.user.uid);
	  				mixpanel.track("first time user", {"email" : result.user.email});
                    firebase.database().ref("users/" + result.user.uid + "/").set({
                        email: result.user.email,
                        photoURL: result.user.photoURL,
                        name: result.user.displayName,
                        firstName: first_name[0]
                    });
                    mixpanel.register({
                        "name": result.user.displayName,
        				"email": result.user.email,
        				"first_name": first_name[0],
        				"id": result.user.uid,
        				"last_login": new Date()
                    });
                    mixpanel.people.set({
	  					"$name": result.user.displayName,
	  					"$email": result.user.email,
	  					"$first_name": first_name[0],
	  					"$id": result.user.uid,
	  					"$last_login": new Date()
	  				});
                }
                
                
                if (user) {
                    console.log("user with email" + user.email + "is signed in");
                    router.push('/dashboard');
                }
              }).catch(function(error) {
                console.log("signin error with errorCode" + error.code + " and message " + error.message); 
              })
          } else {
              console.log("email in Home is " + user.email);
              router.push('/dashboard');
          }
        }
    }
}
</script>


<style scoped>

    .wrapper {
        font-family: Avenir;
    }

    .typed_element{
        color: white;
        font-size:1.65rem;
        font-weight: 500;
        color: #42f498;
    }
    .typed_static {
        color: white;
        font-size:1.65rem;
        font-weight: 500;
        color: #42f498;
    }
    .typed-cursor {
        color:lightgreen;
        margin-left: 5px;
        font-size:32px;
    }
    .signup-btn:hover {
        background-color:#f25792;
        color: #fff;
        border-color: #f25792;
    }
    .message {
        margin-left: 23%;
        margin-top: 5%;
        margin-bottom: 5%;
    }

    .description {
        font-size: 1rem;
        margin-left: 12%;
        margin-right: 12%;
        margin-top: 4%;
        padding-bottom: 4%;
    }

    @media (min-width:992px) {
       .signup-btn {
            margin-top:0%;
            padding-top:1%;
            padding-bottom:1%;
            padding-left:2.8%;
            padding-right:2.8%;
            justify-content: center;
            align-self: center;
            width:12%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius:7px;
            font-weight:500px;
        }    
    }
    @media (max-width:991px) and (min-width:701px){
       .signup-btn {
            margin-top:0%;
            padding-top:1.2% !important;
            padding-bottom:1.2% !important;
            padding-left:3%;
            padding-right:3%;
            justify-content: center;
            align-self: center;
            width:15%;
            margin-top:5%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }
    @media (max-width:700px) and (min-width:576px){
       .signup-btn {
            margin-top:5%;
            padding-top:3.4% !important;
            padding-bottom:3.4% !important;
            padding-left:3%;
            padding-right:3%;
            justify-content: center;
            align-self: center;
            width:37%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }
    @media (max-width:576px) {
       .signup-btn {
            margin-top:0%;
            padding-top:3.5%;
            padding-bottom:3.5%;
            padding-left:3.5%;
            padding-right:3.5%;
            justify-content: center;
            align-self: center;
            width:38%;
            margin-top:5%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }
    @media (max-width:380px) {
       .signup-btn {
            margin-top:0%;
            padding-top:4%;
            padding-bottom:4%;
            padding-left:5%;
            padding-right:5%;
            justify-content: center;
            align-self: center;
            width:40%;
            margin-top:5%;
            margin-bottom:10%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 7px;
        }    
    }    
    
    .header-area {
        color:#fff;
        /*background:linear-gradient(80deg, #5751d1, #798bf2); */
        background:linear-gradient(100deg, #5751d1, #6d7edb);
        padding-bottom: 20px;
    }
    @media(max-width:576px) {
       .header-area {
            color:#fff;
            /*background:linear-gradient(80deg, #5751d1, #798bf2); */
            background:linear-gradient(100deg, #5751d1, #6d7edb);
            padding-bottom:40px;
        } 
    }

    .heading-white {
        font-size: 1.55rem !important;
        margin-top:3%;
        margin-bottom: 2%;
        font-weight: 400;  
    }

    .heading {
        font-size: 1.55rem !important;
        margin-top:3%;
        margin-bottom: 2%;
        font-weight: 400;  
        color: #333;
    }

    .label-heading {
        font-size: 1.25rem;
        margin-bottom: 1.3%;
        font-weight: 400;
        color: #333;
    }

</style>
